import React, { useState } from 'react';
import './home.css';

function Contacts() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    enquiry: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setFormData({ name: '', email: '', phone: '', enquiry: '' });
  };

  return (
    <div className="contact-container">
      <div className="contact-form">
        <h2>Send Us an Enquiry</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            name="enquiry"
            rows="4"
            placeholder="Your Enquiry"
            value={formData.enquiry}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Submit Enquiry</button>
        </form>

        {submitted && (
          <div className="toast">✅ Your enquiry has been successfully submitted!</div>
        )}
      </div>

      <div className="contact-info">
        <h3>Contact Information</h3>
        <p><strong>Contact Number:</strong>0330 058 1634</p>
        <p><strong>Email:</strong> info@orbitenergy.solutions</p>
        <p><strong>Registered Office Address:</strong><br />
          21 Lobelia Road,<br />
          Oxford, England, OX4 6QF
        </p>
        <p>
          We’re here to answer your energy-related questions and help you find the best
          electricity, gas, and merchant services for your business.
        </p>
      </div>
    </div>
  );
}

export default Contacts;
